import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { withSuspense } from './utils';

// Lazy-loaded shared page components
const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage'));
const RequestPasswordResetPage = lazy(
  () => import('@/features/auth/pages/RequestPasswordResetPage')
);
const ResetPasswordPage = lazy(() => import('@/features/auth/pages/ResetPasswordPage'));
const AcceptInvitationPage = lazy(() => import('@/features/auth/pages/AcceptInvitationPage'));
const ProfilePage = lazy(() => import('@/features/profile/ProfilePage'));
const AdminUsersPage = lazy(async () => {
  const module = await import('@/features/admin-users');
  return { default: module.AdminUsersPage };
});
const AdminUserProfilePage = lazy(async () => {
  const module = await import('@/features/admin-users');
  return { default: module.AdminUserProfilePage };
});
const AdminAuditLogPage = lazy(async () => {
  const module = await import('@/features/admin-audit');
  return { default: module.AdminAuditLogPage };
});

/** Public auth routes (login, password reset, invitation) */
export function getPublicRoutes(): RouteObject[] {
  return [
    { path: '/login', element: withSuspense(LoginPage) },
    { path: '/forgot-password', element: withSuspense(RequestPasswordResetPage) },
    { path: '/reset-password', element: withSuspense(ResetPasswordPage) },
    { path: '/accept-invitation/:token', element: withSuspense(AcceptInvitationPage) },
  ];
}

/** Protected routes shared across all apps (profile, admin users, audit) */
export function getSharedProtectedRoutes(): RouteObject[] {
  return [{ path: '/profile', element: withSuspense(ProfilePage) }];
}

/** Admin routes shared across all apps */
export function getSharedAdminRoutes(): RouteObject[] {
  return [
    { path: '/admin/users', element: withSuspense(AdminUsersPage) },
    { path: '/admin/users/:userId', element: withSuspense(AdminUserProfilePage) },
    { path: '/admin/audit', element: withSuspense(AdminAuditLogPage) },
  ];
}
